"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeAsset = exports.Asset = void 0;
const MemoizedBoolean_1 = require("./MemoizedBoolean");
const MemoizedString_1 = require("./MemoizedString");
const ObservableEntity_1 = require("./ObservableEntity");
class Asset extends ObservableEntity_1.ObservableEntity {
}
exports.Asset = Asset;
function makeAsset(id) {
    return new AssetImp(id);
}
exports.makeAsset = makeAsset;
class AssetImp extends Asset {
    get name() {
        return this._memoizedName.val;
    }
    set name(name) {
        this._memoizedName.val = name;
    }
    get description() {
        return this._memoizedDescription.val;
    }
    set description(description) {
        this._memoizedDescription.val = description;
    }
    get archived() {
        return this._memoizedArchived.val;
    }
    set archived(archived) {
        this._memoizedArchived.val = archived;
    }
    get filename() {
        return this._memoizedFilename.val;
    }
    set filename(name) {
        this._memoizedFilename.val = name;
    }
    get fileURL() {
        return this._memoizedFileURL.val;
    }
    set fileURL(name) {
        this._memoizedFileURL.val = name;
    }
    setFile(file) {
        this._file = file;
        this._blobURL = URL.createObjectURL(file);
        this.notify();
    }
    get file() {
        return this._file;
    }
    get blobURL() {
        return this._blobURL;
    }
    get linkedAssets() {
        return [...this._linkedAssets];
    }
    addLinkedAsset(type, id) {
        const existingAsset = this._linkedAssets.find(asset => {
            return asset.id === id;
        });
        if (existingAsset === undefined) {
            this._linkedAssets.push({
                id,
                type
            });
            this.notify();
        }
    }
    removeLinkedAsset(type, id) {
        let foundAsset = false;
        this._linkedAssets.forEach(asset => {
            if (asset.type === type && asset.id === id) {
                foundAsset = true;
            }
        });
        if (foundAsset) {
            this._linkedAssets = this._linkedAssets.filter(asset => asset.id !== id);
            this.notify();
        }
    }
    getLinkedAssetByType(type) {
        const rVal = [];
        this._linkedAssets.forEach(asset => {
            if (asset.type === type) {
                rVal.push(asset.id);
            }
        });
        return rVal;
    }
    get isFetchingFile() {
        return this._memoizedIsFetchingFile.val;
    }
    set isFetchingFile(archived) {
        this._memoizedIsFetchingFile.val = archived;
    }
    get fetchError() {
        return this._fetchError;
    }
    set fetchError(fetchError) {
        if (fetchError === undefined && this.fetchError === undefined)
            return;
        if (fetchError !== undefined && this.fetchError !== undefined &&
            fetchError.message === this.fetchError.message)
            return;
        this._fetchError = fetchError;
        this.notify();
    }
    dispose() {
        if (this._blobURL !== undefined) {
            URL.revokeObjectURL(this._blobURL);
            this._blobURL = undefined;
            this.notify();
        }
    }
    constructor(id) {
        super();
        this._memoizedName = new MemoizedString_1.MemoizedString("", this.notify);
        this._memoizedDescription = new MemoizedString_1.MemoizedString("", this.notify);
        this._memoizedArchived = new MemoizedBoolean_1.MemoizedBoolean(false, this.notify);
        this._memoizedFilename = new MemoizedString_1.MemoizedString("", this.notify);
        this._memoizedFileURL = new MemoizedString_1.MemoizedString("", this.notify);
        this._file = undefined;
        this._blobURL = undefined;
        this._linkedAssets = [];
        this._memoizedIsFetchingFile = new MemoizedBoolean_1.MemoizedBoolean(false, this.notify);
        this._fetchError = undefined;
        this.id = id;
    }
}
